const auth = {
    isLogin() {
        return this.getToken() != "";
    },
    tokenKey: "___APP_SITE_AUTH_TOKEN",
    getToken() {
        let data = this.getTokenData();
        if (data) {
            return data.token ? data.token : "";
        } else {
            return "";
        }
    },
    getTokenData() {
        let val = sessionStorage.getItem(this.tokenKey);
        if (val) {
            let tk = JSON.parse(val);
            if (tk) {
                let ts = new Date().getTime() / 1000;
                if (ts < tk.created + tk.expiry * 60) {
                    return tk.data;
                }
            }
        }
        this.removeToken();
        return null;
    },
    validPrivCode(code) {
        if (!code) {
            return true;
        }
        let data = this.getTokenData();
        if (data && data.privCodes) {
            return data.privCodes.indexOf(code) > -1;
        } else {
            return false;
        }
    },
    validPrivCodeBegin(code) {
        if (!code) {
            return true;
        }
        let data = this.getTokenData();
        if (data && data.privCodes) {
            return data.privCodes.filter((r) => r.indexOf(code) == 0).length > 0;
        } else {
            return false;
        }
    },
    addRouterEach(router) {
        const _vm = this;
        router.beforeEach((to, from, next) => {
            /* 当前路由所有人可见 */
            if (to.meta && to.meta.anonymous === true) {
                next();
            } else if (_vm.isLogin()) {
                if (to.meta && to.meta.privCode && _vm.validPrivCode(to.meta.privCode) === false) {
                    /* 路由需要校验权限，权限不足 */
                    next({ path: "/nopriv" });
                } else {
                    /* 路由需要校验权限，且校验通过 */
                    next();
                }
            } else {
                /* 路由非所有人可见，且未登录 */
                next({ path: "/login" });
            }
        });
    },
    saveToken(data, expiryMin) {
        let max = 1 * 60 * 24 * 365;
        if (!expiryMin || isNaN(expiryMin) || expiryMin > max) {
            /* 过期时间最大不超过 1 年 */
            expiryMin = max;
        }

        let tk = {
            created: new Date().getTime() / 1000,
            expiry: expiryMin,
            data: data,
        };
        sessionStorage.setItem(this.tokenKey, JSON.stringify(tk));
    },
    removeToken() {
        sessionStorage.setItem(this.tokenKey, null);
        sessionStorage.removeItem(this.tokenKey);
    },
};

export default auth;
